import { MatIconModule } from '@angular/material/icon';
import { CommonModule, DatePipe, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Type, ViewEncapsulation } from '@angular/core';
import { FieldTypeConfig, FormlyFieldConfig } from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { DateTime } from 'luxon';

interface InputProps extends FormlyFieldProps {}
export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
    type: 'date-read' | Type<DateReadType>;
}
@Component({
  selector: 'date-read-type',
  encapsulation  : ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone     : true,
  template: `
    <div class= "">
        <p>{{field.formControl.value | date:'dd/MM/yyyy'}}</p>
    </div>
  `,
  imports:[DatePipe]
})
export class DateReadType extends FieldType<FieldTypeConfig<InputProps>>{

    getValue(){
        const value = this.field.formControl.value;
        return value
    }

}
